import * as React from "react";
import styles from "./DashboardPage.module.scss";
import { useState } from "react";
import { DashboardMatterItem } from "components/Dashboard";
import { useEffect } from "react";
import { getMyMattersList } from "api";
import { useNavigate, useLocation } from "react-router";
import MatterForm from "pages/Matters/MatterForm";
import AddClients from "pages/Clients/AddViewClients";
import { useCurrentUser } from "services/currentUserService";

const MyMattersGrid = () => {
  const navigate = useNavigate();
  const [myMatters, setMyMatters] = useState([]);
  const [reference, setReference] = useState();
  const [showMatterForm, setshowMatterForm] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [editData, setEditData] = useState({});
  const [showClientView, setshowClientView] = React.useState(false);
  const location = useLocation();
  const { data: currentUser } = useCurrentUser();

  const isStandaloneDashboard = location.pathname.includes("/sa/dashboard");

  const onClientRefClickActions = (matter) => {
    onClickActions(matter);
  };

  const onMatterRefClickActions = (matter) => {
    onClickActions(matter);
  };

  const onClickActions = (matter) => {
    const matterId = matter?.matterId || matter.matterId;
    if (!matterId) return;

    if (isStandaloneDashboard) {
      window.open(`/sa/casefile/${matterId}`, "_blank");
    } else {
      navigate(`/matters/${matterId}`);
    }
  };

  const getMyMatters = async () => {
    try {
      const data = await getMyMattersList(1, 10, "lastActivityDate desc", {
        feeEarnerRef: currentUser.userRef,
      });
      setMyMatters(data?.data?.data);
    } catch (error) { }
  };

  useEffect(() => {
    getMyMatters();
  }, [currentUser?.userRef]);

  return (
    <div className="h-100 w-100 d-flex flex-column overflow-hidden">
      <div className={`${styles["combo-label-font"]} fw-semibold p-3 ps-4 pb-3 flex-shrink-0`}>
        Recent Matters
      </div>

      <div className="overflow-auto flex-grow-1 mx-2 mb-2 px-1" >
        {myMatters.map((item, index) => (
          <DashboardMatterItem
            key={index}
            item={item}
            onMatterRefClickActions={onMatterRefClickActions}
            onClientRefClickActions={onClientRefClickActions}
          />
        ))}
      </div>

      {showMatterForm && (
        <MatterForm
          isView={reference !== undefined}
          reference={reference}
          onMatterRefClickActions={onMatterRefClickActions}
          setshowMatterForm={() => {
            setshowMatterForm(false);
            setReference(undefined);
          }}
        />
      )}

      {showClientView && !isLoading && (
        <AddClients
          data={editData}
          formId={"view"}
          onClose={() => {
            setshowClientView(false);
          }}
          open={() => {
            setshowClientView(true);
          }}
          reference={reference}
          type={"VIEW"}
        />
      )}
    </div>
  );
};
export default MyMattersGrid;
